import React from "react";
import { FlattenSimpleInterpolation } from "styled-components";

import { StyledTrayHeader, StyledTrayHeaderBtnClose, StyledTrayHeaderTitle } from "./style";

export const DEFAULT_VARIANT = "default";
export const BIG_TITLE_VARIANT = "bigTitle";

interface StyledSideTrayHeaderProps {
  title?: string;
  handleChange?: () => void;
  textStyle?: FlattenSimpleInterpolation;
  useCloseButton?: boolean;
  variant?: typeof DEFAULT_VARIANT | typeof BIG_TITLE_VARIANT;
}

const StyledSideTrayHeader = ({
  title = "",
  handleChange = () => {},
  textStyle,
  useCloseButton = false,
  variant = DEFAULT_VARIANT,
}: StyledSideTrayHeaderProps) => (
  <StyledTrayHeader>
    <StyledTrayHeaderBtnClose
      type="button"
      onClick={handleChange}
      useCloseButton={useCloseButton}
      variant={variant}
    />
    <StyledTrayHeaderTitle variant={variant} textStyle={textStyle}>
      {title}
    </StyledTrayHeaderTitle>
  </StyledTrayHeader>
);

export default StyledSideTrayHeader;
